module.exports = __webpack_public_path__ + "img/discard_silo_img6.81daeb4d.jpeg";